export default {
  'cart.title': 'ตะกร้าสินค้า',
  'cart.order_info': 'ข้อมูลการสั่งซื้อ',
  'cart.action.delete': 'ลบ',
  'cart.payment_status.unpaid': 'ยังไม่ได้ชำระเงิน',
  'cart.payment_status.fail': 'การชำระเงินล้มเหลว',
  'cart.error.out_of_stock': 'สินค้าหมดสต็อก',
  'cart.error.bundle_out_of_stock': 'สินค้าชุดนี้มีจำนวนไม่เพียงพอ',
  'cart.error.product_removed': 'สินค้านี้ถูกนำออกจากระบบ',
  'cart.error.checkout_fail': 'การชำระเงินล้มเหลว',
  'cart.empty_text.one': 'ตะกร้าสินค้าของคุณว่างเปล่า',
  'cart.empty_text.two': 'ไปเลือกซื้อสินค้ากันเถอะ',
  'cart.go_to_checkout': 'ไปที่หน้าชำระเงิน',
  'cart.keep_shopping': 'เลือกซื้อสินค้าต่อ',
  'cart.check_order_status': 'ตรวจสอบสถานะคำสั่งซื้อ',
  'cart.return': 'กลับ',
  'cart.buyer_info': 'ข้อมูลผู้สั่งซื้อ',
  'cart.buyer_info.error.phone_required': 'กรุณาระบุหมายเลขโทรศัพท์',
  'cart.buyer_info.error.phone_formatted': 'รูปแบบหมายเลขโทรศัพท์ไม่ถูกต้อง',
  'cart.buyer_info.error.location_required': 'กรุณาเลือกจังหวัด',
  'cart.buyer_info.error.invoice_carrier.phone.required': 'กรุณาระบุหมายเลขโทรศัพท์มือถือ',
  'cart.buyer_info.error.invoice_carrier.phone.formatted': 'รูปแบบหมายเลขโทรศัพท์มือถือไม่ถูกต้อง',
  'cart.buyer_info.error.invoice_carrier.company.required': 'กรุณาระบุหมายเลขประจำตัวผู้เสียภาษี',
  'cart.buyer_info.error.invoice_carrier.company.formatted':
    'หมายเลขประจำตัวผู้เสียภาษีต้องมี 8 หลัก',
  'cart.buyer_info.error.invoice_carrier.company.verify':
    'การตรวจสอบหมายเลขประจำตัวผู้เสียภาษีล้มเหลว',
  'cart.buyer_info.error.invoice_carrier.company_title.required': 'กรุณาระบุชื่อบริษัท',
  'cart.buyer_info.contact_phone': 'หมายเลขโทรศัพท์',
  'cart.buyer_info.residential_area': 'จังหวัดที่อยู่อาศัย',
  'cart.buyer_info.location': 'เขต/อำเภอ',
  'cart.buyer_info.address': 'ที่อยู่',
  'cart.buyer_info.invoice_carrier': 'ใบกำกับภาษีอิเล็กทรอนิกส์',
  'cart.buyer_info.invoice_carrier.choose': 'เลือกใบกำกับภาษีอิเล็กทรอนิกส์',
  'cart.buyer_info.company.title': 'ชื่อบริษัท',
} as Record<string, string>;
